var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "trail",
              label: _vm.$t(_vm.title_trails),
              icon: "fal fa-sign"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "trail" }
            },
            [
              _c(
                "div",
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
                      _c("p", { staticClass: "q-title" }, [
                        _vm._v(_vm._s(_vm.title))
                      ]),
                      _c("p", { staticClass: "q-body-1 text-weight-light" }, [
                        _vm._v(_vm._s(_vm.description))
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-2" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            label: _vm.$t("back"),
                            color: "primary",
                            icon: "far fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ name: "trails" })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [_c("filter-courses")],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 col-sm-9" }, [
                      _c(
                        "div",
                        { staticClass: "row gutter-md" },
                        [
                          _vm._l(_vm.filteredCourses, function(course, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "col-xs-12 col-sm-12"
                              },
                              [
                                _vm.$q.platform.is.desktop
                                  ? _c("card-desktop", {
                                      key: course.id,
                                      attrs: { course: course },
                                      on: {
                                        clickLike: _vm.clickLike,
                                        clickStars: _vm.clickStars,
                                        clickFavorite: _vm.clickFavorite
                                      }
                                    })
                                  : _vm._e(),
                                _vm.$q.platform.is.mobile
                                  ? _c("card-mobile", {
                                      key: course.id,
                                      attrs: { course: course },
                                      on: {
                                        clickLike: _vm.clickLike,
                                        clickStars: _vm.clickStars,
                                        clickFavorite: _vm.clickFavorite
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm.filteredCourses.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c(
                                    "q-card",
                                    [
                                      _c("q-card-title", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.$t("no_course_found")) +
                                            "\n                                    "
                                        )
                                      ]),
                                      _c("q-card-separator"),
                                      this.search ||
                                      this.selected_areas.length > 0 ||
                                      this.favorite != "all" ||
                                      this.progress != "all" ||
                                      this.selected_groups.length > 0
                                        ? _c("q-card-main", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "no_courses_found_with_this_filter"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _c("q-card-main", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "there_are_no_courses_avaliable_at_the_moment"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ]),
                  _c("modal-stars", {
                    attrs: { show: _vm.show_modal, course: _vm.course },
                    on: { hideModal: _vm.hideModal }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }